import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ShopifyAppBridgeProvider } from '@/providers/AppBridgeProvider';
import { HomePage } from '@/pages/HomePage';
import { SettingsPageRoute } from '@/pages/SettingsPageRoute';
import '@/index.css';

export function App() {
  return (
    <BrowserRouter>
      <ShopifyAppBridgeProvider>
        <Routes>
          <Route path="/settings" element={<SettingsPageRoute />} />
          <Route path="/*" element={<HomePage />} />
        </Routes>
      </ShopifyAppBridgeProvider>
    </BrowserRouter>
  );
}
